import Model from "./Model";

export default class AssemblyParametersStructure extends Model {

	constructor(props) {

		super({});

		this.setDefaultValues({
			general: [
				{ type: 'switch', key: 'dark', default: true, },
				{ type: 'switch', key: 'speech', default: true,  },
				{ type: 'switch', key: 'sound', default: true, },
			],
			component: {},
			dataset: {},
		}, props);
	}
}
